import {gql, useQuery} from '@apollo/client';
import {pickLocalizedText} from '../../../../../utils/i18nText';

/** 审核驳回理由字典项（与 Kotlin ReviewRejectReasonOptionType 对齐：code + 可扩展多语言文案 texts） */
export interface ReviewRejectReasonOption {
    code: string;
    displayOrder?: number;
    texts: {lang: string; text: string}[];
}

export const GET_REVIEW_REJECT_REASON_LIST = gql`
    query GetReviewRejectReasonList {
        getReviewRejectReasonList {
            code
            displayOrder
            texts {
                lang
                text
            }
        }
    }
`;

interface GetReviewRejectReasonListResponse {
    getReviewRejectReasonList: ReviewRejectReasonOption[];
}

/** 审核驳回理由字典（cache-first，全局 4 项预设）。
 *  按 displayOrder 升序由后端保证；前端不再硬编码 i18n key 列表 */
export const useReviewRejectReasons = () => {
    const {data, loading} = useQuery<GetReviewRejectReasonListResponse>(GET_REVIEW_REJECT_REASON_LIST, {
        fetchPolicy: 'cache-first',
    });
    return {
        options: data?.getReviewRejectReasonList ?? [],
        loading,
    };
};

/** 按当前 locale 从字典项 texts 中选展示文案 */
export const pickRejectReasonText = (
    option: ReviewRejectReasonOption | undefined,
    locale: string,
): string => {
    if (!option) return '';
    return pickLocalizedText(option.texts, locale);
};
